module.exports = __webpack_public_path__ + "media/fonts/TomaSlab-Regular-95ed5ffc4a4a24268d0aa7193c3004cc.otf";